import {
  Table as UITable,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatToBRL } from "@/utils/formatToMoney";

import type { IAggregationByAnalyst } from "src/@types/deposit-reconciliation";

import { sumAmountsInCents } from "./sum-in-cents";

export default function AggregationByAnalyst({
  rows,
}: {
  rows: IAggregationByAnalyst[];
}) {
  const total = {
    lotes: rows.reduce((acc, r) => acc + r.lotes, 0),
    conc: sumAmountsInCents(rows, r => r.conciliado),
    nsus: rows.reduce((acc, r) => acc + r.nsus, 0),
  };

  return (
    <div className="border border-slate-200 rounded-md bg-white">
      <div className="border-b border-slate-200 px-3 py-2 bg-slate-50">
        <h3 className="font-semibold text-sm text-slate-700">Por Analista</h3>
      </div>
      <div className="max-h-96 overflow-y-auto">
        <UITable>
          <TableHeader>
            <TableRow>
              <TableHead className="text-xs">Analista</TableHead>
              <TableHead className="text-xs text-right">Conciliações</TableHead>
              <TableHead className="text-xs text-right">Conciliado</TableHead>
              <TableHead className="text-xs text-right">NSUs</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} className="text-xs text-center text-slate-500">
                  Sem dados
                </TableCell>
              </TableRow>
            ) : (
              <>
                {rows.map(r => (
                  <TableRow key={r.email}>
                    <TableCell className="text-xs">{r.name ?? r.email}</TableCell>
                    <TableCell className="text-xs text-right">{r.lotes}</TableCell>
                    <TableCell className="text-xs text-right">
                      {formatToBRL(r.conciliado)}
                    </TableCell>
                    <TableCell className="text-xs text-right">{r.nsus}</TableCell>
                  </TableRow>
                ))}
                <TableRow className="bg-slate-50 font-semibold border-t-2 border-[#2B0C1A]">
                  <TableCell className="text-xs">TOTAL</TableCell>
                  <TableCell className="text-xs text-right">{total.lotes}</TableCell>
                  <TableCell className="text-xs text-right">
                    {formatToBRL(total.conc)}
                  </TableCell>
                  <TableCell className="text-xs text-right">{total.nsus}</TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </UITable>
      </div>
    </div>
  );
}
